// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectRestaurant {
  height: 24px;
  width: 18vw;
  color: #000000;
  font-family: "Montserrat Regular";
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 24px;
}

/* src/SelectRestaurant.scss */
.empty-list {
  font-family: "Montserrat Regular";
  font-size: 20px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectRestaurant/SelectRestaurant.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AACF;;AACA,8BAAA;AACA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAEF","sourcesContent":[".SelectRestaurant {\r\n  height: 24px;\r\n  width: 18vw;\r\n  color: #000000;\r\n  font-family: 'Montserrat Regular';\r\n  font-weight: 400; \r\n  font-size: 16px;\r\n  margin-bottom: 24px;\r\n}\r\n/* src/SelectRestaurant.scss */\r\n.empty-list {\r\n  font-family: 'Montserrat Regular';\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #000000;\r\n  margin-bottom: 24px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SelectRestaurant": `SelectRestaurant`,
	"empty-list": `empty-list`
};
export default ___CSS_LOADER_EXPORT___;
